import React from "react";

/**
 * Art placeholder container. Swap `src` later with final artwork.
 * Keeps layout stable via aspect-ratio classes.
 */
export const Placeholder = ({
  src,
  alt = "Artwork placeholder",
  ratio = "aspect-[3/2]",
  label,
  className = "",
  children,
  testId,
  objectPosition,
  objectFit,
}) => {
  const imgStyle = {};
  if (objectPosition) imgStyle.objectPosition = objectPosition;
  if (objectFit) imgStyle.objectFit = objectFit;
  return (
    <div
      className={`art-placeholder ${ratio} ${className}`}
      data-testid={testId}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          style={Object.keys(imgStyle).length ? imgStyle : undefined}
        />
      ) : null}
      {label ? <span className="art-label">{label}</span> : null}
      {children}
    </div>
  );
};

export default Placeholder;
